import { FC } from 'react';
import { IToastResultDTO } from './types';

export const RecalculationCard: FC<IToastResultDTO> = ({ invoiceNumber, shipmentNumber, workflowStatus, deviations }) => {
  const getStatusColor = (status: string) => {
    if (status?.includes('READY_FOR_PAYMENT')) return 'bg-green-70';
    if (status?.includes('RESOLVED')) return 'bg-green-70';
    if (status?.includes('REJECT')) return 'bg-red-70';
    return 'bg-orange-70';
  };

  const getStatusText = (status: string) => {
    if (status?.includes('READY_FOR_PAYMENT')) return 'Ready for Payment';
    if (status?.includes('RESOLVED')) return 'Resolved';
    if (status?.includes('REJECT')) return 'Rejected';
    if (status?.includes('OPERATION_REVIEW')) return 'Logistic Review';
    if (status?.includes('PROCUREMENT_REVIEW')) return 'Procurement Review';
    if (status?.includes('FINANCE_REVIEW')) return 'Finance Review';
    if (status?.includes('DISPUTE_REVIEW')) return 'Dispute Review';
    if (status?.includes('PROCUREMENT_NO_CONTRACT_REVIEW')) return 'No Contract Review';
    return 'Pending Review';
  };

  return (
    <div className='bg-white rounded-8 p-16'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center gap-16'>
          <div className='flex flex-col'>
            <div className='text-14 font-semibold'>
              {shipmentNumber ? (
                <span>
                  Shipment <span className='text-blue-70'>{shipmentNumber}</span>
                </span>
              ) : (
                <span>
                  Invoice <span className='text-blue-70'>{invoiceNumber}</span>
                </span>
              )}
            </div>
            {invoiceNumber && shipmentNumber && (
              <div className='text-12 text-neutral-80'>
                Invoice <span className='text-blue-70'>{invoiceNumber}</span>
              </div>
            )}
          </div>
        </div>
        <div className={`px-10 py-5 rounded-4 text-12 text-white font-medium ${getStatusColor(workflowStatus)}`}>{getStatusText(workflowStatus)}</div>
      </div>

      {deviations && Object.keys(deviations).length > 0 && (
        <div className='mt-10 pt-10 border-t border-neutral-20'>
          <div className='text-12 font-semibold mb-5'>Deviations:</div>
          <div className='flex flex-wrap gap-8'>
            {Object.entries(deviations).map(([key, value]) => (
              <div key={key} className='bg-neutral-10 rounded-4 px-8 py-4 text-12'>
                {key}: {value}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
